export const COMPONENTS = {
    HOT_KEYS_CHEAT_SHEET: 'hotKeysCheatSheet',
    ANNOTATION_EDITOR: 'annotationEditorForm',
    UPDATE_ANNOTATIONS: 'updateAnnotations',
    SETTINGS_MENU: 'settingsMenu',
};
